import { Construction } from 'lucide-react';

import { Tooltip } from '@/components/ui/tooltip';
import type { CustomerConfig } from '@/entities/customer-config';
import { useMe } from '@/hooks/use-me';
import { FeatureFlag } from '@/types/feature-flag';
import { cls } from '@/utils/cls';

export type SystemLogsInternalIconProps = {
  featureFlag: keyof CustomerConfig['featureFlags'];
  className?: string;
};

export function SystemLogsInternalIcon({
  featureFlag,
  className,
}: SystemLogsInternalIconProps) {
  const me = useMe();

  if (!me.isInternal) {
    return null;
  }

  if (me.config.id === '49') {
    return null;
  }

  const isInternal =
    me.config.featureFlags[featureFlag] === FeatureFlag.INTERNAL;

  if (!isInternal) {
    return null;
  }

  return (
    <Tooltip
      delay
      position="top"
      content={<p>INTERNAL - not yet available for {me.tenant}</p>}
    >
      <Construction
        className={cls('size-4 text-yellow-600', className)}
        aria-label="Internal feature indicator"
      />
    </Tooltip>
  );
}
